import React from 'react'
import PropTypes from 'prop-types'
import styles from './TableSlatePlugin.scss'
import { UncontrolledTooltip, ButtonGroup, Button } from 'reactstrap'
import EditorTooltip from '../EditorTooltip'
import { FaTrash } from 'react-icons/lib/fa'
import * as TablePosition from './deep-table-plugin/TablePosition'
import InsertEmptySpaceButton from '../InsertEmptySpaceButton'

class TableRow extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
    this.uid = Date.now()
  }

  getCurrentRow = state => {
    return state.document.getClosest(
      state.startBlock.key,
      (p) => (p.type === this.props.opts.typeRow)
    )
  }

  render () {
    const { opts, actions, attributes, node, children, readOnly, state, editor: { onChange } } = this.props
    const pos = TablePosition.create(state, state.startBlock, opts)
    const closestRow = this.getCurrentRow(state)
    const focusedOnCurrentNode = closestRow && node.key === closestRow.key
    const isAccordionTitle = node.data.get('isAccordionTitle')
    const showTooltip = !readOnly && focusedOnCurrentNode
    const uid = 'TableRow' + this.uid
    return <tr {...attributes}
      id={uid}
      className={styles.TableRow + ' ' + (isAccordionTitle ? styles.isAccordionTitle : '')}>
      <EditorTooltip state={state} placement='top' className={styles.TableActionsTooltip} isOpen={showTooltip} target={uid} toggle={this.toggle}>
        <div>
          <ButtonGroup style={{marginBottom: '10px'}}>
            <Button
              onClick={e => onChange(actions.onInsertAccordionRow(e, state))}
              color='secondary'
              > <strong>Insert</strong> item
            </Button>
            <Button
              onClick={e => onChange(actions.onRemoveAccordionRow(e, state))}
              color='secondary'
              > <strong>Remove</strong> item
            </Button>
          </ButtonGroup>
          <br />
          <ButtonGroup>
            {
              pos.table && (pos.isFirstRow() || pos.isLastRow()) &&
              <InsertEmptySpaceButton
                before={pos.isFirstRow()}
                after={pos.isLastRow()}
                block={pos.table}
                state={state}
                onChange={onChange} />
            }
            <Button id={uid + 'trash'} onClick={e => onChange(actions.onRemoveTable(e, state))} color='danger'><FaTrash /></Button>
            <UncontrolledTooltip target={uid + 'trash'}>Remove Accordion</UncontrolledTooltip>
          </ButtonGroup>
        </div>
      </EditorTooltip>
      {children}
    </tr>
  }
}

TableRow.propTypes = {
  opts: PropTypes.object,
  actions: PropTypes.object,
  attributes: PropTypes.object,
  node: PropTypes.object,
  readOnly: PropTypes.bool,
  state: PropTypes.object,
  editor: PropTypes.object,
  children: PropTypes.node
}

export default TableRow



// WEBPACK FOOTER //
// ./src/components/DeepTableSlatePlugin/AccordionTableRow.js